export default __webpack_public_path__ + "static/media/68.0385c649.png";